import { Service } from './service'

export class NotificationsService extends Service {
  /**
   * Get all unread notifications
   *
   * @return {ResponseBuilder}
   */
  loadUnreadNotifications () {
    return this._apiRequestBuilder.notifications()
      .loadUnread(this._accountId)
      .json()
      .get()
  }

  /**
   * Read notifications
   *
   * @param ids
   * @return {ResponseBuilder}
   */
  readMessages (ids) {
    return this._apiRequestBuilder.notifications()
      .markRead(this._accountId)
      .data(ids)
      .json()
      .post()
  }

  /**
   * init SSE endpoint
   *
   * @param messagesSSEHandler function handler
   */
  sse (messagesSSEHandler) {
    const url = this._apiRequestBuilder
      .notifications()
      .sse(this._accountId)
      ._composeURL()

    const eventSource = new EventSource(url)
    eventSource.onmessage = messagesSSEHandler
  }
}

export const notificationsService = new NotificationsService()



// WEBPACK FOOTER //
// ./src/js/services/notifications.service.js